<template>
  <svg class="icon symbolIcon"
       aria-hidden="true">
    <use :xlink:href="`#icon-${name}`"></use>
  </svg>
</template>

<script>
const url = process.env.VUE_APP_NAME;
import(`@/${url}/iconfont/iconfont.js`);
export default {
  name: 'symbolIcon',
  props: {
    name: {
      type: String,
      required: false,
      default: 'font-awesome'
    },
  },
}
</script>

<style lang='scss' scoped>
.symbolIcon {
	width: 1em;
	height: 1em;
	vertical-align: -0.15em;
	fill: currentColor;
	overflow: hidden;
}
</style>
